export const STOCK_PRICE_VENUE_ORDER = [
    "binance",
    "bybit",
    "gate",
    "kucoin",
    "asterdex",
];
export const CATALOG_TO_USER_EXCHANGE = {
    binance: "binance",
    bybit: "bybit",
    gate: "gateio",
    kucoin: "kucoin",
    asterdex: "aster",
};
export const USER_EXCHANGE_TO_CATALOG = {
    binance: "binance",
    bybit: "bybit",
    gate: "gate",
    gateio: "gate",
    kucoin: "kucoin",
    aster: "asterdex",
    asterdex: "asterdex",
};
export function canonicalStockTicker(base) {
    const upper = base.trim().toUpperCase();
    if (upper.endsWith("STOCK") && upper.length > "STOCK".length) {
        return upper.slice(0, -"STOCK".length);
    }
    return upper;
}
export function positionSymbolToStockTicker(symbol) {
    let value = symbol.toUpperCase().replace(/[/\s-]/g, "");
    if (value.endsWith("USDTM")) {
        value = value.slice(0, -5);
    }
    else if (value.endsWith("_USDT")) {
        value = value.slice(0, -5);
    }
    else if (value.endsWith("USDT")) {
        value = value.slice(0, -4);
    }
    return canonicalStockTicker(value);
}
function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
export function compileStockTickerRegex(tickers) {
    const unique = [
        ...new Set(tickers
            .map((ticker) => ticker.trim().toUpperCase())
            .filter((ticker) => /^[A-Z0-9]{1,12}$/.test(ticker))),
    ].sort((a, b) => b.length - a.length || a.localeCompare(b));
    if (unique.length === 0)
        return null;
    const parts = unique.map((ticker) => {
        const escaped = escapeRegExp(ticker);
        if (ticker.length >= 3) {
            return `\\$?\\b${escaped}\\b`;
        }
        return `\\$${escaped}\\b`;
    });
    return new RegExp(parts.join("|"), "g");
}
export function findStockTickersInText(text, regex) {
    if (!regex || !text)
        return [];
    const flags = regex.flags.includes("g") ? regex.flags : `${regex.flags}g`;
    const scanner = new RegExp(regex.source, flags);
    const hits = [];
    const seen = new Set();
    let match = scanner.exec(text);
    while (match) {
        const raw = match[0].replace(/^\$/, "").toUpperCase();
        if (!seen.has(raw)) {
            seen.add(raw);
            hits.push({ ticker: raw, index: match.index });
        }
        if (match[0].length === 0)
            scanner.lastIndex += 1;
        match = scanner.exec(text);
    }
    return hits;
}
export function matchStockTickers(title, body, tickers) {
    const regex = compileStockTickerRegex(tickers);
    const titleHits = findStockTickersInText(title, regex);
    const bodyHits = findStockTickersInText(body, regex);
    const ordered = [];
    const seen = new Set();
    for (const hit of [...titleHits, ...bodyHits]) {
        if (seen.has(hit.ticker))
            continue;
        seen.add(hit.ticker);
        ordered.push(hit.ticker);
    }
    return ordered;
}
export function compactSourceLabel(value) {
    return value.toLowerCase().replace(/[^a-z0-9]/g, "");
}
export function isStockNewsSource(source, sourceName, allowlist) {
    const labels = [compactSourceLabel(source)];
    if (sourceName)
        labels.push(compactSourceLabel(sourceName));
    return allowlist.some((entry) => {
        const token = compactSourceLabel(entry);
        if (!token)
            return false;
        return labels.some((label) => label === token || label.includes(token));
    });
}
export function parseStockNewsSources(raw) {
    const value = raw?.trim() || "Bloomberg,US Gov,Terminal";
    return value
        .split(",")
        .map((part) => part.trim())
        .filter((part) => part.length > 0);
}
//# sourceMappingURL=stock-ticker.js.map